import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Overline } from "@/components/site/Reveal";

const faqs = [
  { q: "Which grades and boards do you cover?", a: "We tutor students from Class 1 to Class 8 across all subjects, aligned to CBSE, ICSE and State boards, following your child's own school syllabus and academic calendar." },
  { q: "Are classes 1-on-1 or in batches?", a: "We focus on 1-to-1 sessions and small batches so every child gets genuine attention and doubts are cleared instantly." },
  { q: "How does the weekly schedule work?", a: "In a monthly cycle, Weeks 1 & 3 have 3 classes per subject, while Weeks 2 & 4 have 4, the extra class is reserved for tests, assessments and doubt-clearing. This continues through the academic session." },
  { q: "What are the class durations?", a: "For specific-subject plans: Class 1–5 is 1 hour and Class 6–8 is 1.5 hours per session. For all-subject plans (5 days/week): Class 1–2 is 1.5 hrs, Class 3–5 is 2 hrs and Class 6–8 is 2.5 hrs." },
  { q: "What payment options are available?", a: "Three modes, Monthly, Half-Yearly (with a discount) and Yearly (with a discount). Additional courses come as Monthly (2–3 classes/week) or Yearly (65 classes valid for 12 months)." },
  { q: "Is the demo really free?", a: "Yes. Book a free demo class and our academic counsellor will design a plan tailored to your child before you pay anything." },
];

export const FAQ = () => (
  <section id="faq" className="py-24 md:py-32 bg-muted">
    <div className="max-w-4xl mx-auto px-5 md:px-8">
      <Reveal>
        <Overline>Questions</Overline>
        <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tight">Everything parents ask us.</h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-10 space-y-4" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="bg-white rounded-2xl border border-black/5 px-6">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-heading font-medium text-lg text-left hover:no-underline">{f.q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default FAQ;
